import { useState } from 'react';
import { ShoppingCart, Star, Heart, Share2 } from 'lucide-react';
import whitePolo from '@assets/96D19D92-400F-4E93-9CE3-B6BDA280C37D_1753568184428.png';
import whiteHoodie from '@assets/587EC7CD-A787-42F0-9039-68512E5F5546_1753568184428.png';
import redBeanie from '@assets/A9B68B09-C355-4921-BF41-8ACAA4911516_1753568184428.png';
import athleticDress from '@assets/334DDC63-BAC3-4FD5-8CED-81F95C73FFE9_1753568184428.png';
import greenPolo from '@assets/25D5B044-59F2-4316-9237-7E30431F6F37_1753568184428.png';
import bmzLogo from '@assets/327E9CFA-0EB7-454F-93A8-B69ECA8B5641_1753593855527.png';
import seasonalOutfit from '@assets/446FC077-7100-472A-AD8F-F7E8FAF71B13_1757567237071.png';
import jeansOutfit from '@assets/EEFC5886-219E-4BC0-BDFC-C5B59D83911D_1757567237071.png';


interface MerchItem {
  id: number;
  name: string;
  price: number;
  priceRange?: string;
  originalPrice?: number;
  image: string;
  category: string;
  rating: number;
  reviews: number;
  description: string;
  sizes?: string[];
  colors?: string[];
  inStock: boolean;
  inventory?: number;
  isMTO?: boolean;
  isComingSoon?: boolean;
}

const merchItems: MerchItem[] = [
  {
    id: 1,
    name: 'BLK Seasonal Halloween Outfit - Black & Orange',
    price: 45.00,
    originalPrice: 65.99,
    image: seasonalOutfit,
    category: 'Apparel',
    rating: 5.0,
    reviews: 0,
    description: 'Complete seasonal Halloween outfit featuring black off-shoulder top with orange BLK pumpkin logo and matching orange mini skirt with BLK branding. Sold as complete outfit only. Limited to 100 units.',
    sizes: ['4', '6', '8', '10', '12', '14'],
    colors: ['Black Top & Orange Skirt'],
    inStock: true,
    inventory: 100,
    isMTO: true,
    isComingSoon: true
  },
  {
    id: 2,
    name: 'BLK Crown Polo Dress - White',
    price: 55,
    priceRange: '$55 - $65',
    originalPrice: 79.99,
    image: whitePolo,
    category: 'Apparel',
    rating: 5.0,
    reviews: 0,
    description: 'Elegant white polo dress featuring the iconic BLK crown logo embroidered in navy blue. Premium cotton blend for comfort and style. Limited to 100 units.',
    sizes: ['4', '6', '8', '10', '12', '14'],
    colors: ['White with Navy Trim'],
    inStock: true,
    inventory: 100,
    isMTO: true,
    isComingSoon: true
  },
  {
    id: 3,
    name: 'BLK Crown Hoodie - White',
    price: 62.00,
    originalPrice: 95.99,
    image: whiteHoodie,
    category: 'Apparel',
    rating: 5.0,
    reviews: 0,
    description: 'Premium white hoodie with red BLK crown logo. Made from heavyweight cotton for warmth and durability. Perfect for representing with style. Limited to 80 units.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL', '3XL'],
    colors: ['White with Red Logo'],
    inStock: true,
    inventory: 80,
    isMTO: true,
    isComingSoon: true
  },
  {
    id: 4,
    name: 'BLK Crown Beanie',
    price: 29.99,
    originalPrice: 34.99,
    image: redBeanie,
    category: 'Apparel',
    rating: 5.0,
    reviews: 0,
    description: 'Classic knit beanie featuring embroidered white BLK crown logo. Keep warm while supporting the movement. Available in red and black. Limited to 100 units.',
    colors: ['Red with White Logo', 'Black with White Logo'],
    inStock: true,
    inventory: 100,
    isMTO: true,
    isComingSoon: true
  },
  {
    id: 5,
    name: 'BLK Athletic Dress - Red & White',
    price: 55,
    priceRange: '$55 - $65',
    originalPrice: 89.99,
    image: athleticDress,
    category: 'Apparel',
    rating: 5.0,
    reviews: 0,
    description: 'Sporty athletic dress with red and white diagonal stripe design. Features BLK crown logo and comfortable athletic fabric perfect for active wear or casual style. Limited to 100 units.',
    sizes: ['4', '6', '8', '10', '12', '14'],
    colors: ['Red/White Diagonal'],
    inStock: true,
    inventory: 100,
    isMTO: true,
    isComingSoon: true
  },
  {
    id: 6,
    name: 'BLK Crown Polo Dress - Green & Pink',
    price: 55,
    priceRange: '$55 - $65',
    originalPrice: 84.99,
    image: greenPolo,
    category: 'Apparel',
    rating: 5.0,
    reviews: 0,
    description: 'Vibrant green polo dress with pink collar accents and embroidered BLK crown logo. A bold statement piece for the conscious fashionista. Limited to 100 units.',
    sizes: ['4', '6', '8', '10', '12', '14'],
    colors: ['Green with Pink Accents'],
    inStock: true,
    inventory: 100,
    isMTO: true,
    isComingSoon: true
  },
  {
    id: 7,
    name: 'BLK Crown Classic Outfit - White Tee & Jeans',
    price: 45.00,
    originalPrice: 69.99,
    image: jeansOutfit,
    category: 'Apparel',
    rating: 5.0,
    reviews: 0,
    description: 'Classic coordinated outfit featuring white fitted tee with black BLK crown logo and premium blue jeans with BLK patch detail. Timeless style for everyday wear. Sold as complete outfit only. Limited to 100 units.',
    sizes: ['4', '6', '8', '10', '12', '14'],
    colors: ['White Tee & Blue Jeans'],
    inStock: true,
    inventory: 100,
    isMTO: true,
    isComingSoon: true
  },
  {
    id: 8,
    name: 'BMZ Logo Sticker Pack',
    price: 8.99,
    originalPrice: 12.99,
    image: bmzLogo,
    category: 'Accessories',
    rating: 5.0,
    reviews: 0,
    description: 'Premium Black Media Zone logo sticker pack featuring waterproof vinyl stickers. Perfect for laptops, phones, and water bottles.',
    colors: ['Black/Red Design'],
    inStock: true,
    isMTO: false,
    isComingSoon: false
  }
];

const categories = ['All', 'Apparel', 'Accessories'];

export default function MerchPage() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [cart, setCart] = useState<{[key: number]: number}>({});

  const filteredItems = selectedCategory === 'All' 
    ? merchItems 
    : merchItems.filter(item => item.category === selectedCategory);

  const addToCart = (itemId: number) => {
    setCart(prev => ({
      ...prev,
      [itemId]: (prev[itemId] || 0) + 1
    }));
  };

  const getCartTotal = () => {
    return Object.entries(cart).reduce((total, [itemId, quantity]) => {
      const item = merchItems.find(i => i.id === parseInt(itemId));
      return total + (item?.price || 0) * quantity;
    }, 0);
  };

  const getTotalItems = () => {
    return Object.values(cart).reduce((total, quantity) => total + quantity, 0);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-red-700 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
              Black Book Merch Store
            </h1>
            <p className="text-xl text-gray-800">
              Wear your support for Black-owned businesses with pride
            </p>
          </div>
        </div>
      </div>

      {/* Shopping Cart Summary */}
      {getTotalItems() > 0 && (
        <div className="bg-red-100 border-b border-red-200 py-3">
          <div className="container mx-auto px-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <ShoppingCart className="w-5 h-5 text-red-700" />
                <span className="font-medium text-blue-900">
                  {getTotalItems()} item{getTotalItems() > 1 ? 's' : ''} in cart
                </span>
              </div>
              <div className="text-blue-900 font-bold">
                Total: ${getCartTotal().toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 py-8">
        {/* Category Filter */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2 justify-center">
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-full font-medium transition-colors ${
                  selectedCategory === category
                    ? 'bg-red-700 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredItems.map(item => (
            <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              {/* Product Image */}
              <div className="relative">
                <div className="aspect-square bg-gray-100 flex items-center justify-center overflow-hidden">
                  <img 
                    src={item.image} 
                    alt={item.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                {item.originalPrice && (
                  <div className="absolute top-2 left-2 bg-red-500 text-white px-2 py-1 rounded text-sm font-medium">
                    Sale
                  </div>
                )}
                {item.isMTO && (
                  <div className="absolute top-2 right-2 bg-blue-900 text-white px-3 py-1 rounded text-sm font-bold">
                    MTO
                  </div>
                )}
                {!item.inStock && (
                  <div className="absolute top-2 right-2 bg-gray-500 text-white px-2 py-1 rounded text-sm font-medium">
                    Out of Stock
                  </div>
                )}
              </div>

              {/* Product Info */}
              <div className="p-4">
                <div className="flex items-start justify-between mb-2">
                  <h3 className="font-semibold text-lg text-gray-900">{item.name}</h3>
                  <div className="flex items-center space-x-1">
                    <Heart className="w-4 h-4 text-gray-400 hover:text-red-500 cursor-pointer" />
                    <Share2 className="w-4 h-4 text-gray-400 hover:text-blue-500 cursor-pointer" />
                  </div>
                </div>

                <p className="text-gray-600 text-sm mb-3">{item.description}</p>

                {/* Rating */}
                <div className="flex items-center space-x-1 mb-3">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`w-4 h-4 ${
                          i < Math.floor(item.rating)
                            ? 'text-yellow-400 fill-current'
                            : 'text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">
                    {item.rating} ({item.reviews} reviews)
                  </span>
                </div>

                {/* Price */}
                <div className="flex items-center space-x-2 mb-2">
                  {item.priceRange ? (
                    <span className="text-2xl font-bold text-gray-900">
                      {item.priceRange}
                    </span>
                  ) : (
                    <span className="text-2xl font-bold text-gray-900">
                      ${item.price}
                    </span>
                  )}
                  {item.originalPrice && (
                    <span className="text-lg text-gray-500 line-through">
                      ${item.originalPrice}
                    </span>
                  )}
                </div>
                <div className="text-xs text-gray-500 mb-4">*Taxes added at checkout</div>

                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-3">
                  {item.isMTO && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-purple-100 text-purple-800">
                      MTO - Made to Order
                    </span>
                  )}
                  {item.isComingSoon && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-yellow-100 text-yellow-800">
                      Coming Soon
                    </span>
                  )}
                </div>

                {/* Colors */}
                {item.colors && (
                  <div className="mb-3">
                    <span className="text-sm font-medium text-gray-700 mb-1 block">Colors:</span>
                    <div className="flex space-x-1">
                      {item.colors.map(color => (
                        <span
                          key={color}
                          className="px-2 py-1 text-xs bg-gray-100 rounded"
                        >
                          {color}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Sizes */}
                {item.sizes && (
                  <div className="mb-4">
                    <span className="text-sm font-medium text-gray-700 mb-1 block">Sizes:</span>
                    <div className="flex flex-wrap gap-1">
                      {item.sizes.map(size => (
                        <span
                          key={size}
                          className="px-2 py-1 text-xs bg-gray-100 rounded"
                        >
                          {size}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Inventory */}
                {item.inventory && (
                  <div className="mb-3">
                    <span className="text-sm text-gray-600">
                      Limited Edition: Only {item.inventory} available
                    </span>
                  </div>
                )}

                {/* Add to Cart Button */}
                <button
                  onClick={() => addToCart(item.id)}
                  disabled={!item.inStock}
                  className={`w-full flex items-center justify-center space-x-2 py-3 px-4 rounded-lg font-medium transition-colors ${
                    item.inStock
                      ? 'bg-red-700 hover:bg-red-800 text-white'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  }`}
                >
                  <ShoppingCart className="w-5 h-5" />
                  <span>{item.inStock ? 'Add to Cart' : 'Out of Stock'}</span>
                  {cart[item.id] && (
                    <span className="bg-blue-950 text-white px-2 py-1 rounded-full text-xs">
                      {cart[item.id]}
                    </span>
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredItems.length === 0 && (
          <div className="text-center py-12">
            <div className="text-gray-500 text-lg">No items found in this category.</div>
          </div>
        )}

        {/* Mission Statement */}
        <div className="mt-16 bg-white rounded-lg shadow-md p-8">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Every Purchase Supports Our Mission
            </h2>
            <p className="text-gray-600 mb-6">
              When you buy Black Book merchandise, you're not just getting quality products – 
              you're supporting our mission to connect communities with Black-owned businesses 
              across America. A portion of every purchase goes directly to helping us expand 
              our platform and reach more entrepreneurs.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center mb-8">
              <div>
                <div className="text-2xl font-bold text-red-700">100%</div>
                <div className="text-sm text-gray-600">Quality Guaranteed</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-red-700">25%</div>
                <div className="text-sm text-gray-600">Profits to Community</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-red-700">Free</div>
                <div className="text-sm text-gray-600">Shipping Over $50</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-red-700">MTO</div>
                <div className="text-sm text-gray-600">Made to Order</div>
              </div>
            </div>
            
            {/* Shipping & Return Policy */}
            <div className="bg-gray-50 rounded-lg p-6 text-left">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Shipping & Returns</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
                <div>
                  <p><strong>Shipping:</strong> 5-7 business days for regular items</p>
                  <p><strong>MTO Items:</strong> 2-3 weeks production + shipping</p>
                  <p><strong>Free Shipping:</strong> Orders over $50</p>
                </div>
                <div>
                  <p><strong>Returns:</strong> 30-day return policy</p>
                  <p><strong>Exchange:</strong> Size exchanges available</p>
                  <p><strong>MTO Policy:</strong> Final sale, no returns</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-12 bg-red-700 rounded-lg shadow-md p-8 text-center text-white">
          <h2 className="text-2xl font-bold mb-4">Ready to Support the Movement?</h2>
          <p className="text-green-100 mb-6">
            Join thousands of customers who wear their values and support Black entrepreneurship.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="flex items-center space-x-2 text-green-100">
              <span>💝</span>
              <span>Gift wrapping available</span>
            </div>
            <div className="flex items-center space-x-2 text-green-100">
              <span>📧</span>
              <span>Email support: merch@blackbook.family</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}